import * as angular from 'angular';

import { PropertyType, TimeInterval, ContextualField, ComponentDefinition, PeriodReference } from '../../../models';
import * as Fields from '../../../common/helpers/contextual';

export interface TileConfiguration {
    minPeriod: TimeInterval;
    maxPeriod: TimeInterval;
    aggregationMode: number;
    aggregationPeriod: TimeInterval;
    alignedOn?: PeriodReference;
}

class TileContextualController implements angular.IComponentController {
    isLoading: boolean;
    isLoaded: boolean;
    configuration: TileConfiguration;
    properties: ContextualField[];
    filters: ContextualField[];
    levels: string[];

    static $inject = [];

    constructor() {
        // empty
    }

    $onInit() {
        if (this.configuration.aggregationMode === undefined) {
            this.configuration.aggregationMode = 0;
        }

        this.filters = [];

        this.properties = this.initProperties();
    }

    private initProperties(): ContextualField[] {
        if (this.configuration.alignedOn === undefined) {
            this.configuration.alignedOn = 0;
        }
        const properties: ContextualField[] = [
            {
                modelName: 'minPeriod',
                propertyType: PropertyType.Frequency,
                label: 'Minimum period',
                propertyName: 'minPeriodProperty',
                required: false,
                extraData: {
                    intervalUnitName: 'unit'
                },
                icon: 'fa-calendar-minus-o'
            }, {
                modelName: 'maxPeriod',
                propertyType: PropertyType.Frequency,
                label: 'Maximum period',
                propertyName: 'maxPeriodProperty',
                required: false,
                extraData: {
                    intervalUnitName: 'unit'
                },
                icon: 'fa-calendar-plus-o'
            },
            angular.copy(Fields.PeriodReference),
            {
                modelName: 'aggregationMode',
                propertyType: PropertyType.AggregationMode,
                label: 'Aggregation mode',
                propertyName: 'aggregationMode',
                required: false,
                icon: 'fa-calculator',
            }
        ];
        return properties;
    }
}

export const wtTileContextual: ComponentDefinition = {
    componentId: 'wtTileContextual',
    controller: TileContextualController,
    controllerAs: 'vm',
    template: require('./tileContextual.component.html'),
    bindings: {
        configuration: '<',
        formController: '<'
    }
};